<div class="holder">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <ng-container *ngIf="user">
    <div class="title">
      <p>Conversation with</p>
      <div class="user">
        <profile-picture [user]="user" size="medium"></profile-picture>
        <div class="name">
          <name-tag [user]="user" [hint]="false" size="medium"></name-tag>
        </div>
      </div>
    </div>

    <div
      class="messages"
      #messagePane
      [ngClass]="{ empty: messages.length === 0 }">
      <ng-container *ngIf="messages.length === 0">
        <div>
          <img src="/assets/images/direct-msg-empty.svg" alt />
          <p>Start the conversation by sending a message!</p>
        </div>
      </ng-container>

      <div
        class="msg"
        *ngFor="let msg of messages; index as i"
        [ngClass]="{ received: msg.created_by === user }">
        <div class="bubble greenish-bg">
          <div class="line" *ngFor="let line of lines(msg)">
            <span innerHTML="{{ line }}"></span>
            <br *ngIf="line.length === 0" />
          </div>
        </div>
        <div class="date" *ngIf="showDate(i)">
          {{ msg.created_at | date: 'd/M/yy, h:mma' }}
        </div>
      </div>
    </div>

    <div class="control">
      <textarea
        ngbAutofocus
        placeholder="Write a message ..."
        [(ngModel)]="newMsg"></textarea>
      <div class="buttons">
        <button type="button" class="btn" (click)="dismiss()">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!newMsg || sending"
          (click)="send()">
          Send
          <i class="icon-send-msg"></i>
        </button>
      </div>
    </div>
  </ng-container>
</div>
